// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"55294a2f","123":"2960b4fa","140":"3bc34af6","330":"84b67daf","388":"08f1a0c3","447":"a5cc501c","519":"322d514f","615":"cd7d1070","637":"2bf5136e","702":"b0a1dd20","787":"488ec3a8"}[chunkId] + ".chunk.js";
};